module.exports = __webpack_public_path__ + "instagram.ab010191c9dbc82769fcd9a048579eb2.svg";